import(/* webpackMode: "eager" */ "/vercel/path0/app/research-opportunities/page.tsx");
